const image_url_1 = 'https://media.beehiiv.com/static_assets/site_builder/authors/oliver_buchanan.png';
const OLIVER_BUCHANNON = {
  id: 'author123',
  name: 'Oliver Buchannon',
  profile_picture: {
    thumb: image_url_1,
    url: image_url_1,
    landscape: image_url_1,
  },
};

const image_url_2 = 'https://media.beehiiv.com/static_assets/site_builder/authors/kyra_singh.png';
const KYRA_SINGH = {
  name: 'Kyra Singh',
  profile_picture: {
    thumb: image_url_2,
    url: image_url_2,
    landscape: image_url_2,
  },
  id: 'author2',
};

const image_url_3 = 'https://media.beehiiv.com/static_assets/site_builder/authors/natalia_mirescu.png';
const NATALIA_MIRESCU = {
  name: 'Natalia Mirescu',
  profile_picture: {
    thumb: image_url_3,
    url: image_url_3,
    landscape: image_url_3,
  },
  id: 'author3',
};

const image_url_4 = 'https://media.beehiiv.com/static_assets/site_builder/authors/liam_mckenzie.png';
const LIAM_MCKENZIE = {
  name: 'Liam McKenzie',
  profile_picture: {
    thumb: image_url_4,
    url: image_url_4,
    landscape: image_url_4,
  },
  id: 'author4',
};

const image_url_5 = 'https://media.beehiiv.com/static_assets/site_builder/authors/catalina_vidal.png';
const CATALINA_VIDAL = {
  name: 'Catlina Vidal',
  profile_picture: {
    thumb: image_url_5,
    url: image_url_5,
    landscape: image_url_5,
  },
  id: 'author5',
};

const image_url_6 = 'https://media.beehiiv.com/static_assets/site_builder/authors/allessandro_rossi.png';
const ALESSANDRO_ROSSI = {
  name: 'Alessandro Rossi',
  profile_picture: {
    thumb: image_url_6,
    url: image_url_6,
    landscape: image_url_6,
  },
  id: 'author6',
};

interface Props {
  isExampleSite: boolean;
  authors: any[];
}

const getAuthors = ({ isExampleSite, authors }: Props) => {
  if (isExampleSite) {
    return [OLIVER_BUCHANNON, LIAM_MCKENZIE, KYRA_SINGH, ALESSANDRO_ROSSI, CATALINA_VIDAL, NATALIA_MIRESCU];
  }

  return authors;
};

export { ALESSANDRO_ROSSI, CATALINA_VIDAL, getAuthors, KYRA_SINGH, LIAM_MCKENZIE, NATALIA_MIRESCU, OLIVER_BUCHANNON };
